import { useDesugaredOptionPath } from "./useDesugaredOptionPath.js";
import { useNormalizedOptions } from "./useNormalizedOptions.js";
const useCurrentValues = (optionProps, currentlyChosenEntities) => {
  const desugaredOptionPath = useDesugaredOptionPath(optionProps, void 0);
  return useNormalizedOptions(
    currentlyChosenEntities,
    desugaredOptionPath,
    optionProps
  );
};
export {
  useCurrentValues
};
//# sourceMappingURL=useCurrentValues.js.map
